import type { Duration, Onset, Pixel } from './units/UnitValue';

export type BLCSettings = {
  block: string,
  line: string,
  cell: string,
};

/**
 * One class to handle onset, offset and calculate the duration
 */
export class MusicalTimeCoordinate {
  onset: Onset;

  offset: Onset;

  get duration(): Duration {
    return (this.offset - this.onset) as Duration;
  }

  constructor(onset?: Onset | number, offset?: Onset | number) {
    this.onset = onset as Onset || 0 as Onset;
    this.offset = offset as Onset || 0 as Onset;
  }
}

/**
 * Blocks Lines Cells static constants
 *
 * The 'default_Length' durations are going to define a page with
 * two blocks with one line each, with four cells in each line.
 */
export class BLC {
  static rowHeight = 150 as Pixel;

  static pixelByOnset = 100 as Pixel;

  static verticalSpaceAfterBlock = 50;

  static defaultBlockLabel = 'block';

  static defaultLineLabel = 'line';

  static defaultCellLabel = 'cell';
}

export class Cell extends MusicalTimeCoordinate {
}

export class Line extends MusicalTimeCoordinate {
  cells: Cell[];

  constructor(cells: Cell[], onset?: Onset, offset?: Onset) {
    super(onset, offset);
    this.cells = cells;
  }
}

export class Block extends MusicalTimeCoordinate {
  lines: Line[];

  constructor(lines: Line[], onset?: Onset, offset?: Onset) {
    super(onset, offset);
    this.lines = lines;
  }

  getHeight(): number {
    return (this.lines.length) * BLC.rowHeight + BLC.verticalSpaceAfterBlock;
  }
}
